<ng-container *ngIf="isLoaded; else loaderBlock">
  <div
    class="landing"
    *transloco="let t">
    <div
      class="landing_hero __full-screen"
      appBackgroundBranded>
      <div class="landing_hero_main __wide">
        <div class="fb-panel">
          <div style="flex-grow: 1; display: flex; flex-direction: column">
            <ic-logo class="fb-panel_logo"></ic-logo>

            <h2 class="fb-panel_title">{{ t('auth.find-company.check-your-email-title') }}</h2>

            <div class="fb-panel_row">{{ t('auth.find-company.check-your-email', { email: email }) }}</div>
          </div>
          <span [innerHTML]="t('auth.find-company.contact-us', { supportLink: supportLink })"></span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loaderBlock>
  <app-icon
    class="layout_spinner"
    name="spinner"></app-icon>
</ng-template>
